import { ROUTE } from '../../../../routes';
import { ButtonTypeTokens } from '@voltmoney/schema';
import SharedPropsService from '../../../../SharedPropsService';
import { getAppHeader } from '../../../../configs/config';
import { api } from '../../../../configs/api';
import { nextStepCredStepper } from '../../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const showConfirmationPopup = async (action, _datastore, { instrumentTrack, navigate }) => {
    instrumentTrack("JOINT_HOLDER_KYC_SUMMARY_CONFIRM_BUTTON_CLICKED");
    await navigate(ROUTE.CO_BORROWER_SUMMARY_CONFIRM, {
        name: action.payload.name,
    });
};
export const navigateCoBorrowerPan = async (action, _datastore, { instrumentTrack, navigate, navigateWithClear }) => {
    instrumentTrack("JOINT_HOLDER_ADD_ANOTHER_BUTTON_CLICKED");
    await navigateWithClear(ROUTE.CO_BORROWER_PAN);
};
export const verifyKycSummary = async (action, _datastore, { network, setDatastore, analytics, navigate, navigateWithClear }) => {
    await setDatastore(ROUTE.CO_BORROWER_SUMMARY_CONFIRM, 'continue', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const borrowerId = user.linkedApplications[0].currentCoBorrowerAccountId;
    const response = await network.get(`${api.verifyKYCSummaryForCoBorrower}${applicationId}/${borrowerId}`, { headers: await getAppHeader() });
    await setDatastore(ROUTE.CO_BORROWER_SUMMARY_CONFIRM, 'continue', {
        loading: false,
    });
    if (response.status === 200 && response.data.updatedApplicationObj) {
        user.linkedApplications[0] = response.data.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        const routeObj = await nextStepCredStepper();
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const ToggleKYCSummaryCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.CO_BORROWER_SUMMARY, 'continue', {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const navigateToKYC = async (action, _datastore, { navigate }) => {
    const coBorrowerId = action?.payload?.value;
    const coBorrowerName = action?.payload?.coBorrowerName;
    await navigate(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
        coBorrowerId: coBorrowerId,
        coBorrowerName: coBorrowerName
    });
};
